module.exports = __webpack_public_path__ + "static/media/digital_change.468fc01f.png";